import { memo } from 'react';

import { group, groupEnd, log } from 'helper/debug';
import { WindowType } from 'types/Window';

const GTM_SCRIPT_HREF = 'https://www.googletagmanager.com/gtm.js';
const GtmInjectionMap = {};

type GTMProps = {
	id: string;
	dataLayerRef: string;
};

const GTMInject = ({ id, dataLayerRef = 'dataLayer' }: GTMProps) => {
	if (!id || GtmInjectionMap[id]) {
		return null;
	}

	GtmInjectionMap[id] = true;

	((glob: WindowType, doc: Document, dataLayerName: string, refId: string) => {
		glob[dataLayerName] = glob[dataLayerName] || [];
		glob[dataLayerName].push({
			'gtm.start': new Date().getTime(),
			event: 'gtm.js',
		});

		const firstNode: HTMLElement = doc.getElementsByTagName('script')[0];
		const injectionNode: HTMLScriptElement = doc.createElement('script');
		const dataLayerParam: string = dataLayerName !== 'dataLayer' ? `&l=${dataLayerName}` : '';

		injectionNode.async = true;
		injectionNode.src = `${GTM_SCRIPT_HREF}?id=${refId}${dataLayerParam}`;

		group(`Google Tag Manager`);
		log(`ID: ${refId}\nReference: ${dataLayerName}`);
		groupEnd(`Google Tag Manager`);

		if (firstNode && firstNode.parentNode) {
			firstNode.parentNode.insertBefore(injectionNode, firstNode);
		}
	})(window as any, document, dataLayerRef, `GTM-${id}`);

	return null;
};

export { GTMInject as GTM };
export default memo(GTMInject);
